// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"f0094aaf","261":"f0094aaf","362":"f0094aaf","505":"f0094aaf","766":"f0094aaf","893":"f0094aaf","965":"f0094aaf","975":"f0094aaf"}[chunkId] + ".chunk.css";
};